<template>
  <path
    d="M7.37999 21.0103C7.86999 21.5003 8.65999 21.5003 9.14999 21.0103L17.46 12.7003C17.85 12.3103 17.85 11.6803 17.46 11.2903L9.14999 2.98029C8.65999 2.49029 7.86999 2.49029 7.37999 2.98029C6.88999 3.47029 6.88999 4.26029 7.37999 4.75029L14.62 12.0003L7.36999 19.2503C6.88999 19.7303 6.88999 20.5303 7.37999 21.0103Z"
  />
</template>
